<template>
  <div data-app>
    <div class="d-inline-flex">
      <luci-btn-icon :config="addTerritoryBtnConfig" @callback="$router.push({ name: 'TerritoryCreate' })"></luci-btn-icon>
      <luci-btn-icon :config="refreshTableBtnConfig" @callback="getItems({ sortBy })"></luci-btn-icon>
    </div>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <luci-table :loading="isLoading || deleteLoading" :config="territoryListConfig" @edit-row-callback="editTerritory" @delete-row-callback="openDeleteModal" @sort-by-callback="sortCallback"></luci-table>
    <paging name="territory-list" :view="view" @page="gotoPage"></paging>

    <confirm-modal
      :open="showDeleteModal"
      @yes-callback="deleteTerritory"
      @no-callback="closeDeleteModal"
      :title="'Delete territory?'"
      :message="'Do you want to delete territory: <b>'+ this.territoryToDelete.name +'</b>?'"
    ></confirm-modal>

    <message-modal :open="showMsgModal" @ok-callback="showMsgModal = false"></message-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { split } from 'lodash'

import ConfirmModal from '../modal/ConfirmModal'
import MessageModal from '../modal/MessageModal'
import Paging from '../shared/paging/Paging'
import variables from '../../helpers/variables'

export default {
  computed: {
    ...mapGetters({
      error: 'territory/list/error',
      isLoading: 'territory/list/isLoading',
      items: 'territory/list/items',
      view: 'territory/list/view',
      tableItems: 'territory/list/tableItems',
      deleteError: 'territory/del/error',
      deleteLoading: 'territory/del/isLoading'
    }),
    territoryListConfig () {
      return {
        title: 'Territories',
        showSearch: true,
        items: this.tableItems,
        headers: [
          { text: 'Name', value: 'data.name', sortable: true },
          { text: 'Slug', value: 'data.slug', sortable: true },
          { text: 'Actions', value: 'actions' }
        ],
        pagination: { sortBy: 'data.name' },
        serverSorting: true,
        showButtonDelete: true,
        hideActions: true
      }
    }
  },
  components: {
    ConfirmModal, MessageModal, Paging
  },
  data () {
    return {
      showMsgModal: false,
      showDeleteModal: false,
      territoryToDelete: {},
      addTerritoryBtnConfig: {
        type: 'button',
        name: 'add-territory-btn',
        primary: true,
        icon: true,
        iconType: 'add',
        tooltip: 'Add a new territory'
      },
      refreshTableBtnConfig: variables.refreshBtnIconOptions,
      sortBy: null
    }
  },
  created () {
    this.getItems({ sortBy: this.sortBy })
  },
  methods: {
    ...mapActions({
      getItems: 'territory/list/getItems',
      delete: 'territory/del/del'
    }),
    editTerritory (item) {
      this.$router.push({ name: 'TerritoryUpdate', params: { id: item['@id'] } })
    },
    openDeleteModal (item) {
      this.showDeleteModal = true
      this.territoryToDelete = item
    },
    closeDeleteModal () {
      this.showDeleteModal = false
      this.territoryToDelete = {}
    },
    deleteTerritory () {
      this.showDeleteModal = false
      this.delete(this.territoryToDelete).then(() => {
        if (!this.deleteError) {
          this.territoryToDelete = {}
          this.getItems({ sortBy: this.sortBy })
        } else {
          this.showMsgModal = true
        }
      })
    },
    gotoPage (page) {
      this.getItems({ sortBy: this.sortBy, page: this.view['hydra:' + page] })
    },
    sortCallback (column, descending) {
      const field = split(column, '.')[1]
      const direction = descending ? 'desc' : 'asc'
      this.sortBy = `order[${field}]=${direction}`
      this.getItems({ sortBy: this.sortBy })
    }
  }
}
</script>
